<template>
  <div class="flex items-center">
    <ul class="users-liked user-list">
      <li v-for="(product, productIndex) in params.value" :key="productIndex">
        <vx-tooltip :text="`${product.name} | ${product.LotsProduct.quantity} ${product.unit} | R\$ ${product.LotsProduct.price * product.LotsProduct.quantity}`" position="bottom">
          <vs-avatar :src="product.productPictureUrl" size="30px" class="border-2 border-white border-solid -m-1"/>
        </vx-tooltip>
      </li>
    </ul>
  </div>
</template>

<script>
export default { name: 'CellRendererProducts' }
</script>
